import React from "react";
import { Modal } from "@material-ui/core";
import { styled } from "@mui/material/styles";
import { Box, Button, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
const ModalContainer = styled(Box)`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin: auto;
  height: fit-content;
  width: fit-content;
  border: none;
  outline: none;
  background-color: white;
  box-shadow: 0px 3px 6px #0000000d;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #c5d7f1;
  box-shadow: 0px 3px 20px #185dd21f;
`;
const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ButtonWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  column-gap: 10px;
  margin-top: 20px;
`;
const Message = styled(Typography)`
  font: normal normal 500 14px Open Sans;
  color: #4d4e4f;
  margin-bottom: 6px;
`;
const Title = styled(Typography)`
  font: normal normal 600 20px Open Sans;
  color: #4d4e4f;
`;

const AdvanceCopyAlertDialog = (props) => {
  const handleOpenWhatsapp = () => {
    window.open(`https://wa.me/`, "_blank");
  };
  return (
    <Modal
      open={props.open}
      onClose={() => {
        props.setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalContainer>
        <Wrapper>
          <Title>Max Character Limit Exceeded!</Title>
          <Divider style={{ margin: "10px 0px" }} />
          <Message>
            The message is copied; Click on 'Open WhatsApp' and share it
          </Message>
          <ButtonWrapper>
            <ButtonWrapper>
              <Button
                onClick={() => {
                  props.setOpen(false);
                }}
                variant="contained"
                color="inherit"
                style={{
                  font: "normal normal 600 14px Open Sans",
                  textTransform: "none",
                }}
              >
                Close
              </Button>
              <Button
                onClick={handleOpenWhatsapp}
                variant="contained"
                color="primary"
                style={{
                  font: "normal normal 600 14px Open Sans",
                  width: "fit-content",
                  textTransform: "none",
                }}
              >
                Open WhatsApp
              </Button>
            </ButtonWrapper>
          </ButtonWrapper>
        </Wrapper>
      </ModalContainer>
    </Modal>
  );
};

export default observer(AdvanceCopyAlertDialog);
